/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 15:16:48                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-31 17:00:26                               *
 *****************************************************************************/

/* SUMMARY
  * CompInfoInputNumber: Number compinfo component
*/

/**
* CompInfoInputNumber: Number compinfo component
* @param value - current value
* @param onChange - on value change event
* @param className - additional classname
*/
/** Garde les chiffres, un signe moins et un seul séparateur décimal. */
export function sanitizeCompInfoNumber(raw: string): string {
  const normalized = raw.replace(",", ".");
  const negative = normalized.trim().startsWith("-");
  const digits = normalized.replace(/[^\d.]/g, "");
  const [whole, ...rest] = digits.split(".");
  const decimal = rest.join("");
  return `${negative ? "-" : ""}${whole}${rest.length ? `.${decimal}` : ""}`;
}

export default function CompInfoInputNumber({
  value,
  onChange,
  className = ""
}: {
  value: string,
  onChange: (data: string) => void,
  className?: string
}) {
  return (
    <>
      <input  type="text"
              inputMode="decimal"
              placeholder="ex: ..."
              value={value}
              className={className}
              onChange={(el) => onChange(sanitizeCompInfoNumber(el.target.value))}/>
    </>
  );
}
/***/
